import Dropzone from "react-dropzone";
import { Icon } from "../icon";
import { elementsColor, FileUploadProps } from "./FileUpload.types";
import { useFileUpload } from "./useFileUpload";
import "./FileUpload.style.css";

export function FileUpload({ maxFiles, accept, onUpload }: FileUploadProps) {
  const { _onDrop, onDragEnter, onDragLeave, config } = useFileUpload(onUpload);
  return (
    <Dropzone
      onDrop={_onDrop}
      onDragEnter={onDragEnter}
      onDragLeave={onDragLeave}
      accept={accept}
      maxFiles={maxFiles}
    >
      {({ getRootProps, getInputProps }) => (
        <div
          {...getRootProps()}
          className="file-container mx-auto"
          style={{
            borderColor: config.color,
            borderStyle: config.borderStyle,
            backgroundColor: config.backgroundColor,
            borderWidth: config.borderWidth,
          }}
        >
          <input {...getInputProps()} />
          <Icon size={45} type="fa-regular fa-file" color={elementsColor} />
          <p className="mt-3" style={{ color: elementsColor }}>
            {config.text}
          </p>
        </div>
      )}
    </Dropzone>
  );
}
